import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SsoComponent } from './sso.component';



@NgModule({
  declarations: [SsoComponent],
  imports: [
    CommonModule
  ],
  exports: [SsoComponent]
})
export class SsoModule { }
